import useFeatureFlag from '@customHooks/useFeatureFlag';
import { fetchNotifications } from '@api/useQueryCalls';
import NotificationBell from '@atoms/Notifications/NotificationBell';
import ReferralButton from '@atoms/ReferralButton';
import { Text } from '@components/primitives';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import { FEATURE_FLAGS } from '@root/constants';
import { getStore } from '@store/storeUtils';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import React from 'react';
import { StatusBar, View } from 'react-native';
import styles from './styles';

export function referralCtaHandler(navigation: any): () => void {
  return () => {
    navigation.navigate(navigationConstants.REFERRAL_PAGE, { source: 'tnc_button' });
    AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Referral.referral_button_clicked.name, {});
  };
}

export function shouldShowReferralView(
  navigation: any,
  referralButtonText?: Record<string, string>,
): React.JSX.Element | null {
  if (referralButtonText) {
    return (
      <View style={styles.referralContainer}>
        <ReferralButton onRefferalCta={referralCtaHandler(navigation)} referralButtonText={referralButtonText} />
      </View>
    );
  }
  return null;
}

export function shouldShowNotificationBell(
  isFeatureAvailable?: Record<string, { show: boolean }>,
  notificationCount = 0,
): React.JSX.Element | null {
  if (!isFeatureAvailable?.[FEATURE_FLAGS.NOTIFI_CENTRE]?.show) {
    return null;
  }

  return <NotificationBell notificationCount={notificationCount} />;
}

interface HeaderProps {
  notificationCount?: number;
}

const Header: React.FC<HeaderProps> = ({ notificationCount = 0 }) => {
  const { headerText, referralButtonText } = getStore();
  const navigation = useNavigation();
  const companyName = headerText;
  const [isFeatureAvailale] = useFeatureFlag({ featureName: [FEATURE_FLAGS.NOTIFI_CENTRE] });
  const showNotificationsCentre = isFeatureAvailale?.[FEATURE_FLAGS.NOTIFI_CENTRE]?.show;
  const { data: notificationsResponse } = fetchNotifications({
    category: 'all',
    limit: 1,
    enabled: showNotificationsCentre,
  });
  const unreadCount = showNotificationsCentre
    ? notificationsResponse?.pages?.[0]?.unreadCount ?? notificationCount
    : notificationCount;

  return (
    <View style={styles.headerParent}>
      <StatusBar translucent={false} backgroundColor={colors.secondary.orchid} />
      <Text testID="txtCompanyName" flex={1} color={colors.neutral.cotton} variant="xl-bold">
        {companyName}
      </Text>
      <View style={styles.actionsContainer}>
        {shouldShowNotificationBell(isFeatureAvailale, unreadCount)}
        {shouldShowReferralView(navigation, referralButtonText)}
      </View>
    </View>
  );
};

export default Header;
